export default __webpack_public_path__ + "static/media/question_06.b65cee24.png";